<p-toast></p-toast>
<div class="tecGym-component-Loading" *ngIf="loading">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff" width="30px">
        <path
            d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
    </svg>
</div>
<div class="tecGym-component trainer-dashboard-responsive">
    <div class="tecGym-component-body">
        <div class="mainTopbar" style="display: flex;justify-content: space-between;width: 100%;" >
            <h1>{{setLabel("trainerDashboardLabel")}}</h1>
            <div class="dropdown-main">
                <div class="dropdownDiv">
                    <span style="color: #bfbfbf;" class="stat-label">{{setLabel("selectMonthLabel")}}</span>
                    <div style="color: white; border: 1px solid #0e2031; border-radius: 10em; height: 2em;" class="filterFields">
                        <p-dropdown
                            class="p-inputtext"
                            [options]="monthOptions"
                            name="month"
                            required
                            [(ngModel)]="monthValue"
                            (onChange)="onMonthOrYearChange()">
                        </p-dropdown>
                    </div>
                </div>
               <div class="dropdownDiv">
                <span style="color: #bfbfbf;" class="stat-label">{{setLabel("selectYearLabel")}}</span>
                <div style=" color: white;border: 1px solid #0e2031;border-radius: 10em;height: 2em;"
                    class="filterFields">
                    <p-dropdown class="p-inputtext" [options]="yearOptions" name="year" required [(ngModel)]="yearValue" (onChange)="onMonthOrYearChange()">
                    </p-dropdown>
                </div>
               </div>
            </div>
        </div>
        <div class="tecGym-component-trainer-stat" style="margin-bottom: 20px;">
            <div class="tecGym-component-trainer-stat-item">
                <label>{{setLabel("trainerLabel")}}</label>
                <span>{{trainer.name}}</span>
            </div>
            <div class="tecGym-component-trainer-stat-item">
                <label>{{setLabel("unclaimedTrainerShareLabel")}}</label>
                <span>{{ totalTrainerShare | number:'1.0-0'}}</span>
            </div>
            <div class="tecGym-component-trainer-stat-item">
                <label>{{setLabel("trainerExpensesFromPettyCashLabel")}}</label>
                <span>{{ totalTrainerExpanses | number:'1.0-0'}}</span>
            </div>
            <div class="tecGym-component-trainer-stat-item">
                <label>{{setLabel("trainerBorrowingFromPettyCashLabel")}}</label>
                <span>{{ totalTrainerBorrowed | number:'1.0-0'}}</span>
            </div>
            <div class="tecGym-component-trainer-stat-item">
                <label>{{setLabel("claimableAmountLabel")}}</label>
                <span>{{( totalTrainerShare - totalTrainerExpanses - totalTrainerBorrowed) | number:'1.0-0'}}</span>
            </div>
        </div>
        <p-tabView (onChange)="handleChange($event)">
            <p-tabPanel [header]='setLabel("sessionsHeaderLabel")'>
                <div class="tecGym-component-stats-main tecGym-component-tab-body">
                    <div class="tecGym-component-performance-stats">
                        <div class="tecGym-component-table p-dataView-tecfolk-fix">
                            <h3>{{setLabel("todaySessionsLabel")}} </h3>
                            <p-table [value]="trainingSessionsFiltered" [paginator]="true" [rows]="10">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>{{setLabel("nameLabel")}}</th>
                                        <th>{{setLabel("statusLabel")}}</th>
                                        <th>{{setLabel("actionLabel")}}</th>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-session>
                                    <tr>
                                        <td *ngIf="session.sessionsType == 'classTraining'">{{setLabel("classTrainingLabel")}} </td>
                                        <td *ngIf="session.sessionsType !== 'classTraining'">{{ session.subscriberName }}</td>
                                        <td *ngIf="session.sessionsType == 'classTraining'"> </td>
                                        <td *ngIf="session.sessionsType !== 'classTraining'">{{ session.status }}</td>
                                        <td *ngIf="session.sessionsType !== 'classTraining'" class="trainerDashboardTableBtn"><button pButton type="button"
                                                [pTooltip]='setLabel("presentTooltipLabel")' tooltipPosition="top"
                                                style="margin-right: 10px;" *ngIf="session.status == 'UNMARKED'"
                                                class="p-button-success p-button" icon="fa fa-user"
                                                (click)="markPresent(session)">
                                            </button>
                                            <button pButton type="button" [pTooltip]='setLabel("absentTooltipLabel")'
                                                tooltipPosition="top" style="margin-right: 10px;"
                                                *ngIf="session.status == 'UNMARKED'" class="p-button-danger p-button"
                                                icon="fa fa-user-times" (click)="markAbsent(session)">
                                            </button>
                                            <button pButton type="button"
                                                [pTooltip]='setLabel("rescheduleTooltipLabel")' tooltipPosition="top"
                                                style="margin-right: 10px;" *ngIf="session.status == 'UNMARKED'"
                                                class="p-button" style="background-color: #0a8adf;" icon="fa fa-clock-o"
                                                (click)="reschedule(session)">
                                            </button>
                                        </td>
                                        <td *ngIf="session.sessionsType == 'classTraining'" class="trainerDashboardTableBtn"><button type="button" pButton (click)="openClassAttendanceDialog(session)"
                                            label="Mark Class Attendance"
                                            style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                                        </td>
                                    </tr>

                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel [header]='setLabel("customersHeaderLabel")'>
                <div class="tecGym-component-stats-main tecGym-component-tab-body">
                    <div class="tecGym-component-performance-stats">
                        <div class="tecGym-component-table p-dataView-tecfolk-fix">
                            <p-table [value]="customers" [paginator]="true" [rows]="10">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="customersThead">{{setLabel("tagNumberLabel")}}</th>
                                        <th class="customersThead">{{setLabel("nameLabel")}}</th>
                                        <th class="customersThead">{{setLabel("totalSubscriptionsLabel")}}</th>
                                        <th class="customersThead">{{setLabel("totalSessionsLabel")}}</th>
                                        <th class="customersThead">{{setLabel("attendedSessionsLabel")}}</th>
                                        <th class="customersThead">{{setLabel("missedSessionsLabel")}}</th>
                                        <th class="customersThead">{{setLabel("totalFeePaidLabel")}}</th>
                                        <th class="customersThead">{{setLabel("trainerShareLabel")}}</th>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-customer>
                                    <tr class="tbody">
                                        <div>
                                            <span>{{setLabel("tagNumberLabel")}}</span>
                                            <td>{{ customer.subscriberMembership }}</td>
                                        </div>
                                        <div>
                                            <span>{{setLabel("nameLabel")}}</span>
                                            <td>{{ customer.subscriberName }}</td>
                                        </div>
                                        <div>
                                            <span>{{setLabel("totalSubscriptionsLabel")}}</span>
                                            <td>{{ customer.totalSubscriptions }}</td>

                                        </div>
                                        <div>
                                            <span>{{setLabel("totalSessionsLabel")}}</span>
                                            <td>{{ customer.totalSessions }}</td>
                                        </div>
                                        <div>
                                            <span>{{setLabel("attendedSessionsLabel")}}</span>
                                            <td>{{ customer.totalAttendedSessions }}</td>
                                        </div>
                                        <div>
                                            <span>{{setLabel("missedSessionsLabel")}}</span>
                                            <td>{{ customer.totalMissedSessions }}</td>

                                        </div>
                                        <div>
                                            <span>{{setLabel("totalFeePaidLabel")}}</span>
                                            <td>{{ customer.totalPay | number:'1.0-0'}}</td>

                                        </div>
                                        <div>
                                            <span>{{setLabel("trainerShareLabel")}}</span>
                                            <td>{{ customer.trainershare | number:'1.0-0'}}</td>
                                        </div>
                                        </tr>

                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<div *ngIf="sessionsDialog">
    <app-training-session-attd [sessionId]="sessionId" [presentClicked]="presentClicked"
        [rescheduleClicked]="rescheduleClicked"
        (closeTrainingSessionsDialog)="closeTrainingSessionsDialog()"></app-training-session-attd>
</div>
<p-dialog style="font-weight: 600;" header="Class Training"
                (onHide)="hideModal()" [(visible)]="classSessionsDialog" class="dialogPop">
                <form class="payout-main-wrapper" #TrainingSessionsDialogForm="ngForm"
                    style="width: 320px; text-align: inherit;">
                    <div >
                        <span >{{setLabel("trainerNameLabel")}}  </span>
                        <span style="font-weight: lighter;" >{{trainer.name}}</span>
                    </div>
                    <div *ngFor="let member of members" style="display: flex; justify-content: space-between;align-items: center;">
                        <label style="display: block;">
                            {{ member.name }}
                        </label>
                        <input type="checkbox" style="width: auto;" [checked]="member.attendedStatus === 'ATTENDED'" (change)="changeAttendedStatus(member)">
                    </div>
                    <div>
                        <button type="button" pButton (click)="markClassAttendance()"
                            label="Mark Class Attendance"
                            style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                    </div>
                </form>
            </p-dialog>